import React from "react";
import PropTypes from "prop-types";
import Datasheet from "react-datasheet";
import { OrderedMap } from "immutable";
import { Card, Button, Icon } from "antd";
import { ObjectSelectEditor } from "components";
import { UI_LIST_ITEM_TYPES } from "constants";
import "styles/form.css";
import { NEW_BUSINESS_NATURE_TYPES, CONSTITUTION_TYPES, BUSINESS_CATEGORY_TYPES, BOOLEAN_OPTIONS } from "constants/enums";
const COMPANY_PROFILE_FIELDS = new OrderedMap({
    name: {
        label: "Name",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    nature_of_business: {
        label: "Nature of Business",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: NEW_BUSINESS_NATURE_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={NEW_BUSINESS_NATURE_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    mode={"multiple"}
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    date_of_incorporation: {
        label: "Date of Incorporation",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        // dataType: "DATE",
        // component: (() => {
        //     const comp = props => (
        //         <DatePickerEditor
        //             // dateFormat={"DD-MM-YYYY"}
        //             {...props}
        //         />);
        //     comp.displayName= "DataSheetDatePickerEditor";
        //     return comp;
        // })()
    },
    business_start_date: {
        label: "Business Start Date",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        // dataType: "DATE",
        // component: (() => {
        //     const comp = props => (
        //         <DatePickerEditor
        //             // dateFormat={"DD-MM-YYYY"}
        //             {...props}
        //         />);
        //     comp.displayName= "DataSheetDatePickerEditor";
        //     return comp;
        // })()
    },
    constitution: {
        label: "Constitution",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: CONSTITUTION_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={CONSTITUTION_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    pan: {
        label: "PAN",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    gstin: {
        label: "GSTIN",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    cin: {
        label: "CIN",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    registration_num: {
        label: "Registration Number",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    business_category: {
        label: "Business Category",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: BUSINESS_CATEGORY_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={BUSINESS_CATEGORY_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    num_of_employees: {
        label: "No. of Employees",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    company_cibil_score: {
        label: "CIBIL Score",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    company_cibil_remarks: {
        label: "CIBIL Remarks",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    is_active: {
        label: "Is Active",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: BOOLEAN_OPTIONS,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={BOOLEAN_OPTIONS.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    }
});

class CompanyProfileForm extends React.Component {
    state = {
        data: [],
        final_data: []
    };

    edit = true;
    componentDidMount() {
        this.edit = true;
        this.setState({
            data: this.generateCols()
        });
    }
    generateCols() {
        let grid = COMPANY_PROFILE_FIELDS
            .map((_, key) => {
                if(_.type === UI_LIST_ITEM_TYPES.SECTION) {
                    return [
                        {
                            value: _.label,
                            readOnly: true,
                            type: _.type,
                            colSpan: 2
                        }
                    ];
                }
                return [
                    {
                        value: _.label,
                        readOnly: true,
                        type: _.type
                    },
                    {
                        // value: String(_.render(key, "fixed")),
                        value: this.props.values &&
                            this.props.values[key] ? 
                            (
                                _.options ?
                                    typeof this.props.values[key] === "object" && this.props.values[key].length > 0 ?
                                        _.options.findKey(_ => _ === this.props.values[key][0]) :
                                        _.options.findKey(_ => _ === this.props.values[key]) :
                                    String(this.props.values[key])
                            ) : 
                            null,
                        type: _.type,
                        dataType: _.dataType,
                        itemKey: key,
                        dataEditor: _.component
                    }
                ];
            })
            .toList()
            .toArray();
        return grid;
    }

    handleCellChange = changes => {
        this.edit = true;
        this.saveActive = true;
        const grid = this.state.data.map(row => [...row]);
        changes.forEach(({ row, col, value }) => {
            let error = false;
            // if (
            //     value &&
            //     value.length > 0 &&
            //     isNaN(Number(value))
            // ) {
            //     error = true;
            //     this.saveActive = false;
            // }
            grid[row][col] = {
                ...grid[row][col],
                value,
                className: error ? "error-cell" : null
            };
        });
        this.setState({ data: grid });
    }

    save = () => {
        this.saveActive = false;
        const obj = {};
        this.state.data
            .filter(_ => _[0].type === UI_LIST_ITEM_TYPES.LIST_ITEM)
            .map(([, v]) => {
                obj[v.itemKey] = v && v.value && typeof v.value === "object" ? 
                    (v.value.length > 0  ? v.value.map(__ => (__.value || __.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) :                   
                    v.value === "" ? 0 : 
                        typeof v.value === "string" ? 
                            v.value : Number(v.value);
            });
        const newCompanyProfile = this.props.companyProfile.merge(obj);
        // const newCompanyProfile = this.props.companyProfile.withMutations(mut => {
        //     Object.keys(obj).map(_ => {
        //         console.log(_, obj[_]);
        //         mut.set(_, obj[_]);
        //     });    
        // });
        // console.log(this.props.companyProfile);
        this.props.updateCompanyProfile(newCompanyProfile);
    }

    cellRenderer = (cell) => {
        if(cell && cell.dataType === "SELECT") {
            return cell.value ? cell.options.findKey(_ => _ === cell.value) : "";
        }
        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && (cell.value.name || cell.value.label )) {
            return cell.value ? (cell.value.name ? cell.value.name : cell.value.label) : "";
        }

        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && typeof cell.value !== "string" && cell.value.length > 0) {
            return cell.value ? (cell.value.map(_ => _.name ? _.name : _.label).join("; ")) : "";
        }

        if(cell.value && cell.value._isAMomentObject) {
            return cell.value.format("DD-MM-YYYY");
        }

        if(cell.value && isNaN(cell.value)) {
            return cell.value;
        }
        if(!cell.value) {
            return "--";
        }
        return cell.value;
    }

    render() {
        return (
            <React.Fragment>
                <Card
                    title={"Company Profile"}
                    className={"padless-card mb-10"}
                    extra={[
                        <Button
                            key="action-save"
                            // disabled={!this.saveActive}
                            type={"link"}
                            onClick={this.save}
                        >
                            Save <Icon type={"save"} />
                        </Button>
                    ]}
                >
                    <div className={"spreadsheet-table"}>
                        <Datasheet
                            data={this.state.data}
                            valueRenderer={(cell) => this.cellRenderer(cell)}
                            onCellsChanged={this.handleCellChange}
                        />
                    </div>
                </Card>
            </React.Fragment>
        );
    }

}

CompanyProfileForm.propTypes = {
    values: PropTypes.object,
    updateCompanyProfile: PropTypes.func,
    companyProfile: PropTypes.object
};

export default CompanyProfileForm;